<div class="contains-button">
    <!-- --------------------------------------------------------- TIÊU ĐỀ MỞ RỘNG --------------------------------------------------------- -->
    <div class="editor-header" *ngIf="isViewAll">
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>

    <!-- ----------------------------------------------------------- MENU CONFIG ----------------------------------------------------------- -->
    <ng-container *ngIf="!isViewAll">
        <app-position-out-config 
            [elementChoosing]="objectChoosing" 
            [device]="device" 
            [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
        </app-position-out-config>

        <app-width-height-config   
            [device]="device"   
            [elementChoosing]="objectChoosing" 
            [width]="class['video']['width']" 
            [height]="class['video']['height']"
            (changeWidthHeight)="changeWidthHeight($event)">
        </app-width-height-config>


        <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
            <!-- THAY ĐỔI ĐƯỜNG DẪN -->
            <li *ngIf="['AtwVideo'].includes(objectChoosing.component)"
            nz-submenu [nzTitle]="'thay_doi_duong_dan' | translate" 
            class="p-0 m-0 " style="line-height: 20px;"
            [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
                <div class="d-flex justify-content-between align-items-center">
                    <span class='w-50'>{{ 'loai_video' | translate }}</span>
                    <nz-select [ngModel]="staticdata.type_video || 'youtube'"
                        (ngModelChange)="staticdata.type_video = $event; updateStaticData()">
                        <nz-option nzValue="youtube" nzLabel="Youtube"></nz-option>
                        <nz-option nzValue="tiktok" nzLabel="Tiktok"></nz-option>
                        <nz-option nzValue="instagram" nzLabel="Instagram"></nz-option>
                        <nz-option nzValue="facebook" nzLabel="Facebook"></nz-option>
                    </nz-select>
                </div>

                <!-- Nút hướng dẫn chèn video -->
                <button nz-button [nzType]="'primary'" class="btn_iframe"
                    style="margin:10px 0px;  white-space: normal;line-height: 15px;min-height: 30px"
                    (click)="showModal()">
                    {{'huong_dan_chen_video' | translate}}
                </button>

                <div class="iframe_title">
                    <!-- Ô nhập đường dẫn -->
                    <textarea #myInput nz-input class="input_iframe" nzSize="large" 
                        [nzAutosize]="{ minRows: 1, maxRows: 8 }"
                        [placeholder]="placeHolder" 
                        [(ngModel)]="srcInput" width="150px"></textarea>
                </div>
                
                <!-- Nút cập nhật đường dẫn -->
                <button nz-button class="btn_iframe" nzType="primary" (click)="getLink(srcInput)">
                    {{'cap_nhat' | translate}}
                </button>

                <div *ngIf="!staticdata.type_video || staticdata.type_video == 'youtube'" class="iframe_block">
                    <p style="line-height: 1.4; font-size: 13px; color: #333; font-style: italic; text-align: justify; margin: 12px 0;">
                        {{'de_hien_thi_cau_hinh_tu_dong_phat_thi_can_tat_am_thanh_vi_hau_het_trinh_duyet_se_chan_tu_dong_phat_neu_video_youtube_co_am_thanh' | translate}}
                    </p>

                    <!-- ÂM THANH -->
                    <div class="border-type mt-4">
                        <h4>{{'am_thanh' | translate}}</h4>
                        <nz-switch [(ngModel)]="objectChoosing.staticdata.is_mute"
                            (ngModelChange)="setMute($event,'mute')"></nz-switch>
                    </div>

                    <!-- TỰ ĐỘNG LẶP -->
                    <div class="border-type">
                        <h4>{{'tu_dong_lap' | translate}}</h4>
                        <nz-switch [(ngModel)]="objectChoosing.staticdata.loop"
                            (ngModelChange)="setLoop($event,'loop')"></nz-switch>
                    </div>

                    <!-- THÀNH CÔNG CỤ -->
                    <div class="border-type">
                        <h4>{{'thanh_cong_cu' | translate}}</h4>
                        <nz-switch [(ngModel)]="objectChoosing.staticdata.controls"
                            (ngModelChange)="SetDisplaySetting($event,'controls')"></nz-switch>
                    </div>

                    <!-- TỰ ĐỘNG PHÁT -->
                    <!-- autoplay phải đi với mute, nên nếu không mute thì autoplay sẽ tự động set false (Xem tại https://developer.chrome.com/blog/autoplay/) -->
                    <div *ngIf="!objectChoosing.staticdata.is_mute" class="border-type">
                        <h4>{{'tu_dong_phat' | translate}}</h4>
                        <nz-switch [(ngModel)]="objectChoosing.staticdata.autoplay"
                            (ngModelChange)="setAutoplay($event, 'autoplay')"></nz-switch>
                    </div>
                </div>
            </li>
            <!-- KIỂU VIỀN -->
            <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap['menu' + objectChoosing.component == 'AtwVideo' ? '2' : '1']"
            (nzOpenChange)="openHandler('menu' + objectChoosing.component == 'AtwVideo' ? '2' : '1')">
                <app-borders-config [device]="device"
                    [elementChoosing]="objectChoosing"
                    [class]="class"
                    [borderClass]="class['video__iframe']"
                    [id_object]="objectChoosing._id">
                </app-borders-config>
                <!-- Nút mở rộng -->
                <div class="item-border my-3" style="float: right; cursor: pointer;">
                    <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
                </div>
            </li>
            <!-- TỐI ƯU CHỈ SỐ HỖ TRỢ TIẾP CẬN -->
            <li nz-submenu nzTitle="{{'toi_uu_Chi_so_Ho_tro_tiep_can' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
                <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate">
                    <mat-label>{{'mo_ta_ngan_gon_noi_dung' | translate}}<span style="color: red">*</span></mat-label>
                    <textarea matInput
                        [ngModel]="staticdata.accessibility?.['title_' + functionService.selectedLanguageCode] || 'Video youtube'"
                        (ngModelChange)="staticdata.accessibility['title_' + functionService.selectedLanguageCode] = $event"
                        (blur)="updateContent('title', true);"></textarea>
                </mat-form-field>
            </li>
            <!-- ẨN HIỆN -->
            <li class="p-0" nz-submenu [nzTitle]="'an_hien' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
                <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
                </app-hide-show-config>
            </li>
        </ul>
    </ng-container>

    <!-- -------------------------------------------------------- CẤU HÌNH CHI TIẾT -------------------------------------------------------- -->
    <div class="view-more" *ngIf="isViewAll">
        <!-- Cấu hình chi tiết đường viền -->
        <div class="view_more-border" *ngIf="currentViewAll.index == 1">
            <app-borders-radius-config
                [elementChoosing]="objectChoosing"
                [device]="device"
                [class]="class"
                [borderRadiusClass]="class['video__iframe']"
                [id_object]="objectChoosing._id">
            </app-borders-radius-config>
        </div>
    </div>
</div>

<!-- ------------------------------------------------- HỘP THOẠI HƯỚNG DẪN CHÈN VIDEO -------------------------------------------------- -->
<nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="handleCancel()" [nzFooter]="null"
    [nzStyle]="{ height: '500px', top: ' 10px' }" [nzWidth]="'70%'">
    <ng-container *nzModalContent>
        <div class="modal-success">
            <ng-container *ngIf="staticdata.type_video == 'youtube'">
                <h4 class="title">
                    {{'huong_dan_khach_hang_chen_video_youtube_vao_trang_web' | translate}}
                </h4>
                <div class="list-image">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_B1.jpg" alt="image 1">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_youtube_muon_chen_sau_do' | translate }}
                            <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Share</span></span>
                            {{ 'o_duoi_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b2.jpg" alt="image_2">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 2:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Embed</span></span>
                            {{ 'de_lay_ma_nhung' | translate }}.
                        </div>
                    </div>
                </div>
                <div class="list-image pt-2">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b3.jpg" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 3:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Copy</span></span>,
                            {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 4:
                            <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                            {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="staticdata.type_video == 'tiktok'">
                <h4 class="title">
                    {{'huong_dan_khach_hang_chen_video_tiktok_vao_trang_web' | translate}}
                </h4>
                <div class="list-image">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_tiktok_b1.png" alt="image 1">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_tiktok_muon_chen_sau_do' | translate }}
                            <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Share</span></span>
                            {{ 'o_duoi_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_tiktok_b2.png" alt="image_2">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 2:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Embed</span></span>
                            {{ 'de_lay_ma_nhung' | translate }}.
                        </div>
                    </div>
                </div>
                <div class="list-image pt-2">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_tiktok_b3.png" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 3:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Copy</span></span>,
                            {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 4:
                            <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                            {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="staticdata.type_video == 'facebook'">
                <h4 class="title">
                    {{'huong_dan_khach_hang_chen_video_facebook_vao_trang_web' | translate}}
                </h4>
                <div class="list-image">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_facebook_b1.png" alt="image 1">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_facebook_muon_chen_sau_do' | translate }}
                            <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Share</span></span>
                            {{ 'o_duoi_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_facebook_b2.png" alt="image_2">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 2:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Embed</span></span>
                            {{ 'de_lay_ma_nhung' | translate }}.
                        </div>
                    </div>
                </div>
                <div class="list-image pt-2">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_facebook_b3.png" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 3:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Copy</span></span>,
                            {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 4:
                            <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                            {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="staticdata.type_video == 'instagram'">
                <h4 class="title">
                    {{'huong_dan_khach_hang_chen_video_instagram_vao_trang_web' | translate}}
                </h4>
                <div class="list-image">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_instagram_b1.png" alt="image 1">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_instagram_muon_chen_sau_do' | translate }}
                            <span style="color:#00a859"> {{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Share</span></span>
                            {{ 'o_duoi_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_instagram_b2.png" alt="image_2">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 2:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Embed</span></span>
                            {{ 'de_lay_ma_nhung' | translate }}.
                        </div>
                    </div>
                </div>
                <div class="list-image pt-2">
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_instagram_b3.png" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 3:
                            <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{
                                    'nut' | translate}} Copy</span></span>,
                            {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
                        </div>
                    </div>
                    <div class="item-image">
                        <img src="/assets/root/images/system/imgs/video_b4.jpg" alt="image 3">
                        <div class="note-content">
                            {{ 'buoc' | translate }} 4:
                            <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} <span
                                    style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> </span>
                            {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</nz-modal>
